import { render, staticRenderFns } from "./MenuSlider.vue?vue&type=template&id=259a82ce&scoped=true"
import script from "./MenuSlider.vue?vue&type=script&lang=js"
export * from "./MenuSlider.vue?vue&type=script&lang=js"
import style0 from "./MenuSlider.vue?vue&type=style&index=0&id=259a82ce&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.39_css-loader@6.11.0_webpack@5.108.4_cssnano@5_9449f7de44cb275de9d2805a6df01d68/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259a82ce",
  null
  
)

export default component.exports